import { PageCard } from "src/common/styles/styles"
import { IncomeRecordForm } from "../IncomeRecordForm"
import { IncomeRecord } from "src/common/models/incomeRecord"
import { Loader } from "src/components/Loader"
import { PayableContractError } from "src/features/PayableContract/state/types"
import { CancelConfirmationModal } from "src/common/descriptions/components/cancelConfirmationModal"
import { ModalSuccess } from "src/components/ModalSuccess"
import { SystemDescriptions } from "src/common/descriptions"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/state/reducer"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { CREATE_INCOME_RECORD_API } from "src/features/CashboxStatement/state/actionTypes"
import { Urls } from "src/common/urls"
import { createIncomeRecordApi } from "src/features/CashboxStatement/state/action"
import { useNavigate } from "react-router"

interface ReduxProps {
    error?: PayableContractError
    createIncomeRecordSuccess: boolean
    isCreatingRecord: boolean
}

export const CreateIncomeRecord = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const descriptions = SystemDescriptions.PAGES.PAYABLE_CONTRACT.CREATE_INCOME_RECORD

    const [modalConfirmationOpen, setModalConfirmationOpen] = useState<boolean>(false)
    const [modalCancelOpen, setModalCancelOpen] = useState<boolean>(false)
    const [formValues, setFormValues] = useState<IncomeRecord | undefined>()
    const [actionButtonClicked, setActionButtonClicked] = useState<boolean>(false)

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        error: state.payableContract.error,
        createIncomeRecordSuccess: state.cashbox.createIncomeRecordSuccess,
        isCreatingRecord: serviceLoading(state, [CREATE_INCOME_RECORD_API]),
    }))

    const onFinish = (customer: Partial<IncomeRecord>) => {
        setFormValues(customer as IncomeRecord)
        setModalConfirmationOpen(true)
    }

    const onCancel = () => {
        setModalCancelOpen(true)
    }

    const handleConfirmationAccept = () => {
        setModalConfirmationOpen(false)
        setActionButtonClicked(true)
        dispatch(createIncomeRecordApi(formValues as IncomeRecord))
    }

    const handleCancelAccept = () => {
        console.log("alolah")
        navigate(Urls.FRONTEND.EXPENDITURE_RECORD.RECORDS)
    }

    const renderModals = () => (
        <>
            <CancelConfirmationModal
                isVisible={modalConfirmationOpen}
                onAccept={handleConfirmationAccept}
                onCancel={() => {
                    setModalConfirmationOpen(false)
                }}
                title={descriptions.CONFIRM_MODAL.TITLE}
                okText={descriptions.CONFIRM_MODAL.ACTION_BUTTON}
                cancelText={descriptions.CONFIRM_MODAL.CANCEL_BUTTON}
                description={descriptions.CONFIRM_MODAL.DESCRIPTION}
            />
            <CancelConfirmationModal
                isVisible={modalCancelOpen}
                onAccept={handleCancelAccept}
                onCancel={() => { setModalCancelOpen(false) }}
                title={descriptions.CANCEL_MODAL.TITLE}
                okText={descriptions.CANCEL_MODAL.ACTION_BUTTON}
                cancelText={descriptions.CANCEL_MODAL.CANCEL_BUTTON}
                description={descriptions.CANCEL_MODAL.DESCRIPTION}
            />
            <ModalSuccess
                isVisible={(reduxProps.createIncomeRecordSuccess) && actionButtonClicked}
                title={descriptions.SUCCESS_MODAL.TITLE}
                description={descriptions.SUCCESS_MODAL.DESCRIPTION}
                onPrimaryAction={handleCancelAccept}
                onSecondaryActiont={handleCancelAccept}
                primaryLabel={descriptions.SUCCESS_MODAL.PRIMARY_LABEL}
                secondaryLabel={descriptions.SUCCESS_MODAL.SECONDARY_LABEL}
                hideSecondaryButton={true}
            />
        </>
    )

    const renderLoader = () => (
        <Loader
            isVisible={reduxProps.isCreatingRecord}
            title={descriptions.MAIN_ACTION_TITLE}
            description={descriptions.MAIN_ACTION_DESCRIPTION}
        />
    )

    return (
        <>
            <PageCard
                size="small"
                title={descriptions.TITLE}
            >
                <IncomeRecordForm
                    onFinish={onFinish}
                    onCancel={onCancel} />
            </PageCard>
            {renderModals()}
            {renderLoader()}
        </>
    )
}
